<div class="main">
    @defer (when !faultyVehicleDataService.pureOriginalsIsLoading()) {
        <div class="table-container"
             infinite-scroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="2"
             [infiniteScrollDisabled]="!faultyVehicleDataService.canLoadMoreOriginals()"
             (scrolled)="faultyVehicleDataService.onPureOriginalsScroll()">

            <app-pure-originals-table
                    [pureOriginals]="faultyVehicleDataService.faultyPureOriginals()"
                    [actionsTemplate]="customActions"
                    [sortDirectionValues]="faultyVehicleDataService.sortDirectionValues()"
                    [displayedTableHeaders]="faultyVehicleDataService.displayedTableHeaders()"
                    [displayedOriginalColumns]="faultyVehicleDataService.displayedOriginalColumns()"
                    (changeSortDirection)="changeSortDirection($event)"
                    [headerActionButton]="true"
                    [isLoadingTemplate]="isLoading()"
                    [headerButtonResetValue]="resetHeaderActionValue()"
                    [disableSortButton]="false"
                    (selectedIdsOutput)="getSelectedIdOutputs($event)"
            />

            <ng-template #customActions let-element>
                <div class="actions-row">
                    <button class="table-buttons" [disabled]="!element.id"
                            (click)="openPureOriginalDetails(+element.id)">
                        <i class="bi bi-eye"></i>
                    </button>
                    <div class="checkbox-wrapper-18">
                        <div class="round">
                            <input type="checkbox" [id]="element.id"
                                   [checked]="isElementSelected(+element.id)"
                                   (change)="viewDetails($event, element)"/>
                            <label [for]="element.id"></label>
                        </div>
                    </div>
                </div>
            </ng-template>
            @if (faultyVehicleDataService.pureOriginalsError()) {
                <div class="records-state" role="alert">{{ faultyVehicleDataService.pureOriginalsError() }}
                    <button type="button" (click)="faultyVehicleDataService.retryPureOriginals()">Retry</button>
                </div>
            } @else if (faultyVehicleDataService.pureOriginalsIsLoading()) {
                <div class="records-state" role="status">Loading Pure Originals…</div>
            }
        </div>
    } @placeholder (minimum 300ms) {
        <div class="skeleton-wrapper">
            <app-skeleton-table></app-skeleton-table>
        </div>
    }

    <div class="button-container">
        <button class="submit-button" (click)="submitPureOriginalIds()">
            Submit ({{ pureOriginalIds().length }} selected)
        </button>
    </div>
</div>
